import { compose } from '../../utils';
import { changeMixin } from '../../componentsMixins/mixins/changeMixin';
import { inputEventsDispatchingMixin } from '../../componentsMixins/mixins/inputEventsDispatchingMixin';
import { inputValidationMixin } from '../../componentsMixins/mixins/inputValidationMixin';
import { normalizeBooleanAttributesMixin } from '../../componentsMixins/mixins/normalizeBooleanAttributesMixin';
import { createBaseClass } from './createBaseClass';

export const createBaseInputClass = (...args) =>
  compose(
    inputValidationMixin,
    changeMixin,
    normalizeBooleanAttributesMixin,
    inputEventsDispatchingMixin
  )(createBaseClass(...args));
